import { styled } from '@mui/system';
import { Stack } from '@mui/material';

export const Row = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
}));
